import { render } from "./AddonViewProcessingColor.vue?vue&type=template&id=9c54e81a&scoped=true&ts=true"
import script from "./AddonViewProcessingColor.vue?vue&type=script&lang=ts"
export * from "./AddonViewProcessingColor.vue?vue&type=script&lang=ts"

import "./AddonViewProcessingColor.vue?vue&type=style&index=0&id=9c54e81a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c54e81a"]])

export default __exports__